var _rect, _rect2, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDashboardCampaignManagement(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.16699,
    y: 0.5,
    width: 31,
    height: 31,
    rx: 7.5,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1.16699,
    y: 0.5,
    width: 31,
    height: 31,
    rx: 7.5,
    stroke: "#E4E4E4"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7381_152524)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.0625 14.6235C27.0614 13.4967 26.6132 12.4165 25.8165 11.6197C25.0198 10.823 23.9395 10.3749 22.8127 10.3737H19.289C19.0313 10.3587 14.5416 10.0426 10.2661 6.45682C10.0597 6.28343 9.808 6.17255 9.54071 6.13722C9.27341 6.10189 9.00159 6.14357 8.75717 6.25737C8.51274 6.37116 8.30587 6.55235 8.16085 6.77965C8.01583 7.00694 7.93868 7.2709 7.93848 7.54052V21.7065C7.93851 21.9762 8.01554 22.2403 8.16049 22.4677C8.30544 22.6951 8.51231 22.8764 8.75676 22.9903C9.00122 23.1042 9.27312 23.146 9.54049 23.1107C9.80786 23.0754 10.0596 22.9645 10.2661 22.7911C13.6102 19.9862 17.0835 19.1823 18.563 18.9574V21.7658C18.5627 21.9992 18.62 22.2291 18.73 22.435C18.84 22.6409 18.9992 22.8165 19.1933 22.946L20.1672 23.595C20.3555 23.7206 20.5711 23.7993 20.796 23.8245C21.0209 23.8497 21.2486 23.8207 21.46 23.7398C21.6714 23.6589 21.8603 23.5285 22.0109 23.3596C22.1615 23.1907 22.2695 22.9882 22.3258 22.7689L23.3679 18.8414C24.3902 18.7054 25.3284 18.2027 26.008 17.4269C26.6876 16.6511 27.0623 15.6549 27.0625 14.6235ZM9.35507 21.7003V7.54052C13.1454 10.7199 17.0251 11.5247 18.563 11.723V17.5204C17.0268 17.7223 13.148 18.5253 9.35507 21.7003ZM20.9535 22.4086V22.4183L19.9796 21.7694V18.8733H21.892L20.9535 22.4086ZM22.8127 17.4567H19.9796V11.7903H22.8127C23.5642 11.7903 24.2848 12.0888 24.8161 12.6201C25.3474 13.1515 25.6459 13.8721 25.6459 14.6235C25.6459 15.3749 25.3474 16.0955 24.8161 16.6269C24.2848 17.1582 23.5642 17.4567 22.8127 17.4567Z",
    fill: "#7F7F7F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7381_152524"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(7.5 5.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardCampaignManagement);
export default __webpack_public_path__ + "static/media/dashboardCampaignManagement.7731294053bcc9be0886551e7eebfc74.svg";
export { ForwardRef as ReactComponent };